import React from 'react'
import AdminAirdrop from '../../Component/adminComp/AdminAirdrop'

const AirdropWallets = () => {
  return (
    <AdminAirdrop/>
  )
}

export default AirdropWallets